export class SelectItem {
  constructor(public value: string, public name: string, public selected: boolean = false, public disabled: boolean = false) {
  }
}
